import { isCatalogEvent } from "@/features/catalog/mediators/catalogEvents";
import {
  type CatalogPageEffect,
  type CatalogPageEvent,
  type CatalogPageState,
  isCatalogPageEvent,
  transitionCatalogPage,
} from "@/features/catalog/mediators/catalogPageMediator";
import {
  createMediator,
  type Mediator,
  type TypedEvent,
} from "@/shared/lib/componentHierarchy";
export type BoardPageEvent =
  | CatalogPageEvent
  | { type: "board/thread-create-toggle-requested" }
  | { type: "board/catalog-requested" };
export type BoardPageEffect =
  | CatalogPageEffect
  | { type: "board/catalog-requested" };
export function isBoardPageEvent(event: TypedEvent): event is BoardPageEvent {
  return (
    event.type === "board/catalog-requested" ||
    event.type === "board/thread-create-toggle-requested" ||
    (isCatalogEvent(event) && isCatalogPageEvent(event))
  );
}
export function createBoardPageMediator(
  isDesktop: boolean,
  runEffect: (effect: BoardPageEffect) => void,
  getIsThreadCreateOpen: () => boolean = () => false,
  restoredState?: CatalogPageState,
): Mediator<CatalogPageState, BoardPageEvent, BoardPageEffect> {
  return createMediator<CatalogPageState, BoardPageEvent, BoardPageEffect>(
    {
      isDesktop,
      isThreadCreateOpen: getIsThreadCreateOpen(),
      isSettingsOpen: restoredState?.isSettingsOpen ?? false,
      isSortOpen: restoredState?.isSortOpen ?? false,
      isTagFilterOpen: restoredState?.isTagFilterOpen ?? false,
    },
    (state, event) => {
      if (event.type === "board/thread-create-toggle-requested")
        return transitionCatalogPage(state, {
          type: "catalog/thread-create-toggle-requested",
        });
      if (event.type === "board/catalog-requested")
        return {
          status: "handled",
          state,
          effects: [event],
        };
      return transitionCatalogPage(state, event);
    },
    { runEffect },
  );
}
